import apiClient, { unwrapData } from "./apiClient";
import { startCall } from "./callsApi";
import { getLeadContextLeads, getLeadContextStatus } from "./leadsApi";

export async function startOutboundCall(payload, options = {}) {
  const aiConfigId = String(payload?.ai_config_id || "").trim();

  const data = await startCall(
    {
      ai_config_id: aiConfigId || undefined,
      phone: String(payload?.phone || "").trim(),
      patient_name: String(payload?.patient_name || payload?.name || "").trim(),
      reason: String(payload?.reason || "follow-up").trim(),
      contact_id: payload?.contact_id,
      client_id: payload?.client_id,
      campaign_id: payload?.campaign_id,
      trunk: payload?.trunk,
      caller_id: payload?.caller_id,
      timeout_seconds: payload?.timeout_seconds,
      channel_type: "ai",
      metadata: {
        ...(payload?.metadata || {}),
        source: payload?.metadata?.source || "dashboard",
        reason: String(payload?.reason || "follow-up").trim(),
        ai_config_id: aiConfigId || undefined,
      },
    },
    options,
  );

  return {
    provider: "Backend ARI",
    ...data,
  };
}

async function getContactsAsLeads(options = {}) {
  const response = await apiClient.get("/api/contacts", {
    ...options,
    query: { limit: 200, ...(options.query || {}) },
  });
  const data = unwrapData(response) || {};
  const contacts = Array.isArray(data) ? data : data.contacts || data.items || [];

  return contacts
    .filter((c) => c.phone || c.phone_number)
    .map((c) => ({
      id: c.contact_id || c.id,
      full_name: c.name || [c.first_name, c.last_name].filter(Boolean).join(" ") || "Unknown",
      phone: c.phone || c.phone_number || "",
      email: c.email || "",
      lead_score: null,
      pam_task: "follow_up",
      next_best_action: "General follow-up",
      summary_text: c.notes || "",
      _source: "contacts",
    }));
}

export async function getOutboundQueueLeads(options = {}) {
  const status = await getLeadContextStatus(options).catch(() => null);
  const leadContextEnabled = status?.enabled !== false;

  if (leadContextEnabled) {
    const leads = await getLeadContextLeads({
      ...options,
      query: { callable: true, sort: "priority", ...(options.query || {}) },
    });
    const leadList = Array.isArray(leads) ? leads : leads?.leads || [];

    if (leadList.length > 0) {
      return leadList;
    }
  }

  return getContactsAsLeads(options);
}
